module.exports = __webpack_public_path__ + "img/yunyouchuanqi.81853b8e.jpg";